<template>
<div>
    <h1 class="subtitle">Ordenes de Compra y Servicio</h1>
    <div class="nj-panel">
        <div class="nj-panel-content">
            <Filters>
                <template #filters>
                    <div class="nj-grid g3">
                        <InputSelect label="Tipo de orden" v-model="orden_compra.ord_tipo_orden" :source="tipos_orden" itemKey="id" itemValue="id" itemFilter="nombre"
                            :labelFunction="(item) => item.nombre">
                        </InputSelect>
                        <InputText label="Orden (ID o Código)" v-model="orden_compra.ord_code"></InputText>
                        <InputDate label="Fecha inicio" v-model="orden_compra.fecha_inicio"></InputDate>
                        <InputDate label="Fecha fin" v-model="orden_compra.fecha_fin"></InputDate>
                    </div>
                </template>
                <template #buttons>
                    <Button label="Buscar" icon="search" @click="buscar()"></Button>
                </template>
            </Filters>
            <br>
            <b-table :data="ordenes" :total="orden_compra.page.total" :per-page="orden_compra.page.size" :current-page="orden_compra.page.number" :pagination-rounded="true" :paginated="true"
                :backend-pagination="true" @page-change="pageChange($event)" pagination-position="bottom">
                <template slot-scope="props">
                    <b-table-column label="Orden" header-class="is-info">{{ props.row.ord_code }}</b-table-column>
                    <b-table-column label="Tipo" header-class="is-info">{{ props.row.ord_tipo_orden_descripcion }}</b-table-column>
                    <b-table-column label="Fecha" header-class="is-info">{{ props.row.ord_fecha_orden }}</b-table-column>
                    <b-table-column label="Registrado por" header-class="is-info">{{ props.row.ord_usu_logistica }}</b-table-column>
                    <b-table-column label="Condición" header-class="is-info">{{ props.row.coc_descripcion }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-tag :class="props.row.ore_styles">{{ props.row.ore_descripcion }}</b-tag>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flex">
                            <Button title="Ver orden" icon="info" @click="popup({ view: 'ProveedorVerOrdenCompra', ord_id: props.row.ord_id })"></Button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <ProveedorVerOrdenCompra v-if="view == 'ProveedorVerOrdenCompra'" :ord_id="ord_id" @close="popup($event)"></ProveedorVerOrdenCompra>
</div>
</template>
<script>
import { OrdenCompraService, ResponseStatus, OpcionesService } from "../../services"
import { Toast, Tools, Validator } from "../../util"
import { Button, Filters, InputText, InputDate, InputSelect } from "../components"
import ProveedorVerOrdenCompra from "./ProveedorVerOrdenCompra.vue"
export default {
    name: "ProveedorOrdenCompra",
    components: {
        InputText,
        InputSelect,
        Filters,
        Button,
        InputDate,
        ProveedorVerOrdenCompra,
    },
    data() {
        return {
            orden_compra: {
                ord_code: null,
                ord_tipo_orden: null,
                ore_id: null,
                fecha_inicio: null,
                fecha_fin: null,
                page: {
                    number: 1,
                    size: 10
                }
            },
            ordenes: [],
            tipos_orden: [],
            view: null,
            ord_id: null,
        }
    },
    methods: {
        buscar() {
            OrdenCompraService
                .paginarxProveedor({
                    orden_compra: this.orden_compra
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.orden_compra.page = response.data
                        this.ordenes = this.orden_compra.page.list
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        pageChange(page) {
            this.orden_compra.page.number = page
            this.buscar()
        },
        popup({
            view,
            ord_id,
            buscar = false
        }) {
            this.view = view
            this.ord_id = ord_id
            if (buscar) {
                this.buscar()
            }
        },
    },
    mounted() {
        if (Validator.isNotNull(this.$route.params.message)) {
            // * indicando al usuario que no tiene acceso a la ruta ingresada
            Toast.error(this.$route.params.message)
        }
        OpcionesService
            .getOpciones({
                tipo_orden: {},
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.tipos_orden = response.data.tipos_orden
                    this.buscar()
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>